module.exports = __webpack_public_path__ + "static/media/logo-pink.243e75b8.svg";